<template>
  <div class='revision-history-branch'>
    <div class="revision-history-branch__header">
      <span class='revision-history-branch__label'>
        {{label}}
      </span>
      <x-flag
        :scale="1.2"
        @click.native="deleteBranch"
      ></x-flag>
    </div>
    <div class="revision-history-branch__footer">
      <span>
        <span class='revision-history-branch__audience'>
          {{totalAudience}}
        </span>
        <template v-if="!isCurrentBranch">
          <positiveity-indicator
            :number='changeInAudience'
            :message='changeInAudienceMessage'>
          </positiveity-indicator>
          <oval-button
            class="revision-history-branch__goto"
            @click.native="goto"
          >
            GOTO
          </oval-button>
        </template>
      </span>
    </div>
  </div>
</template>

<script>
import {formatSmallNumber} from '@/helpers'
import {PositiveityIndicator} from '@/components/common/positiveityIndicator'
import {OvalButton} from '@/components/common/ovalLabel'
import XFlag from '@/components/common/xFlag'

export default {
  components: {
    PositiveityIndicator,
    OvalButton,
    XFlag
  },
  props: {
    label: {
      type: String,
      required: true
    },
    audience: {
      type: Number,
      required: true
    },
    currentAudience: {
      type: Number,
      required: true
    },
    isCurrentBranch: {
      type: Boolean,
      default: false
    },
    goto: {
      type: Function,
      default: () => {}
    },
    deleteBranch: {
      type: Function,
      default: () => {}
    }
  },
  computed: {
    totalAudience () {
      return 'Total Audience: ' + formatSmallNumber(String(this.audience))
    },
    changeInAudience () {
      return this.audience - this.currentAudience
    },
    changeInAudienceMessage () {
      return formatSmallNumber(String(Math.abs(this.changeInAudience)))
    }
  }
}
</script>

<style lang='scss'>
.revision-history-branch {

  &__header {
    margin-top: 10px;
  }

  &__footer {
    margin-bottom: 5px;
  }

  &__label {
    padding-top: 5px;
    padding-left: 15px;
    padding-bottom: 10px;
  }

  &__audience {
    padding-left: 15px;
    padding-bottom: 5px;
    margin-right: 10px;
  }
  &__goto {
    background-color: green;
    margin-left: 15px;
    border-color: green !important;
    color: white;
  }
}

</style>



// WEBPACK FOOTER //
// Branch.vue?05545edb